<template>
  <div>
    <ContentSectionLoader v-if="isLoading" />
    <Transition name="fade">
      <section class="max-w-lg mx-auto">
        <form
          v-if="!isLoading"
          @submit.prevent="submitForm"
        >
          <FormBuilderFieldSet
            class="mb-8"
            :form="form"
            :show-outline="outline"
            :submission="formSubmission"
            :union-slug="unionSlug"
            :flat-picker-date-format="flatPickerDateFormat"
            @submissionUpdated="updateSubmission"
          />
          <button
            type="submit"
            class="btn"
            :class="{ 'load btn--disabled': formSubmission.busy }"
            :disabled="formSubmission.busy"
            v-text="'Submit'"
          />
        </form>
      </section>
    </Transition>
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import Form from 'Base/Resources/assets/js/plugins/Form'
import FormBuilderFieldSet from './FormBuilderFieldSet'

export default {
  name: 'FormBuilder',
  components: {
    FormBuilderFieldSet,
  },
  props: {
    formUuid: {
      type: String,
      required: true,
    },
    unionSlug: {
      type: String,
      required: true,
    },
    flatPickerDateFormat: {
      type: String,
      required: true,
    },
    outline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      formSubmission: null,
      readyForSubmission: true,
      isLoading: true,
    }
  },
  computed: {
    form() {
      return this.$store.state.form.form
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.dispatch('formSetForm', this.formUuid)
      .then(() => {
        this.resetSubmission()

        this.isLoading = false
      })
  },
  methods: {
    resetSubmission() {
      const fields = {}

      this.form.fields.data.forEach((field) =>  {
        fields[field.attributes.slug] = ''
      })

      this.formSubmission = new Form(fields)
    },
    updateSubmission(event) {
      this.formSubmission = event.submission
    },
    submitForm() {
      const vm = this

      this.formSubmission.startProcessing()

      this.$api.active().post(`forms/${this.formUuid}/submit`, this.formSubmission)
        .then(() => {
          window.location.href = new URI(window.location.href).setSearch({
            status: 'The form was submitted successfully!',
          }).toString()
        }).catch((errors) => {
          vm.formSubmission.setErrors(errors.response.data)

          vm.$store.commit('baseAddNotification', {
            type: 'error',
            title: 'Error',
            text: (vm.formSubmission.errors.message),
          })
        })
    },
  },
}
</script>
